<template>
  <div class="playwright-test">
    <h1>Playwright Test Page</h1>
    <button id="api-button" @click="callApi">Call API</button>
    <div id="loading" v-if="loading">Loading...</div>
    <div id="api-result">{{ result }}</div>
  </div>
</template>

<script>
export default {
  name: 'PlaywrightTestPage',
  data () {
    return {
      loading: false,
      result: ''
    }
  },
  methods: {
    async callApi () {
      this.loading = true
      try {
        const res = await this.$http.get('/commentator-backend/publicApi/v2/initConfig', { timeout: 5000 })
        if (res && res.data && typeof res.data.message !== 'undefined') {
          this.result = res.data.message
        } else {
          this.result = 'API Call Success!'
        }
      } catch (e) {
        this.result = 'API Call Failed'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.playwright-test {
  padding: 24px;
}
#api-button {
  margin: 12px 0;
}
</style>
